import NetworkLogic from "../Shared/NetworkLogic";
import UIManager from "../Shared/UIManager";
import { Global } from "../Shared/Global";
import Player from "../Models/Player";
import AudioManager from "../Shared/AudioManager";
import RegisterUI from "./RegisterUI";

const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class LoginCompleteInformation extends RegisterUI {


    async start() {
        cc.sys.localStorage.setItem("OpenRegister", "");
        this.nodeItems.active = false
        this._channelCode = Global.installParms[0];
        this._bindData = Global.installParms[1];
        await this.downloadUserConfig();
        if(!this._userLoginConfig)return ;
        let registerTypeCfg = this._userLoginConfig["userLoginConfig"] || []
        for (let i = 0 ;i < registerTypeCfg.length;i++){//获取区号
            let cfg = registerTypeCfg[i];
            if  (cfg["registerFieldName"] === "phone"){
                await this.areaLanguageFlag();
                break;
            }
        }
        this.showItemsFromLoginConfig()
        this.refreshCodeImage()
    }

    protected downloadUserConfig():Promise<void> {
        return new Promise((reslove)=>{
            UIManager.showLoadingUI()
            NetworkLogic.userLoginConfig({
                agentCode: this._bindData["code"] || "",
            },function (data) {
                UIManager.hideLoadingUI()
                this._userLoginConfig = data;

                reslove();
            }.bind(this),function (){
                reslove();
            })
        })
    }


    protected check(): boolean {
        // if  (!this.currencyLanguageDto){
        //     UIManager.showToastUI(i18n.t('register_chooseCurrency'), Global.ToastType.Warnning)
        //     return false;
        // }
        if (this.ebUserName.string.length === 0) {
            UIManager.showToastUI(i18n.t('register_text.user_not_mag'), Global.ToastType.Warnning)
            return false
        } else if (this.ebUserName.string.length < 6 || this.ebUserName.string.length > 12 || !(/\d+/.test(this.ebUserName.string) && /[a-zA-Z]+/.test(this.ebUserName.string)) ) {
            UIManager.showToastUI(i18n.t('register_text.user_pro'), Global.ToastType.Warnning)
            return false
        }
        if (/\s/.test(this.ebUserName.string)){
            UIManager.showToastUI(i18n.t('register_text.user_pro'), Global.ToastType.Warnning)
            return false

        }
        if (/\s/.test(this.ebPossword.string)){
            UIManager.showToastUI(i18n.t('register_text.paw_pro'), Global.ToastType.Warnning)
            return false
        }
        let pwdRegex = /[^0-9A-Za-z~！\\\\@#￥%&()*-_=+{}[]|;:''"",.<>?]+/g;
        if (pwdRegex.test(this.ebPossword.string)){
            UIManager.showToastUI(i18n.t('register_text.paw_pro'), Global.ToastType.Warnning)
            cc.log("===不行");
            return false
        }

        if (this.ebPossword.string.length === 0) {
            UIManager.showToastUI(i18n.t('login_text.psw_pro'), Global.ToastType.Warnning)
            return false
        } else if (this.ebPossword.string.length < 6 || this.ebPossword.string.length > 12 ) {
            UIManager.showToastUI(i18n.t('register_text.paw_pro'), Global.ToastType.Warnning)
            return false
        }

        if (this.ebConfirm.string.length === 0) {

            UIManager.showToastUI(i18n.t('register_text.confirm_paw_pro'), Global.ToastType.Warnning)
            return false
        } else if (this.ebConfirm.string !== this.ebPossword.string) {
            UIManager.showToastUI(i18n.t('register_text.paw_consistent'), Global.ToastType.Warnning)
            return false
        }

        // 注册图形验证码
        if (parseInt(this._userLoginConfig["isOpenReCode"]) === 0) {
            if (this.ebCode.string.length === 0) {
                UIManager.showToastUI(i18n.t('register_text.paw_pro'), Global.ToastType.Warnning)
                return false
            }
        }

        let registerTypeCfg = this._userLoginConfig["userLoginConfig"] || []

        for (let i = 0; i < registerTypeCfg.length; i++) {
            const cfg = registerTypeCfg[i];
            let editBox = null;
            if (cfg["registerFieldName"] === "phone"){
                editBox = this.ebPhoneNum;
            }else{
                editBox = cc.find(cfg["registerFieldName"] + "/EditBox", this.nodeContent).getComponent(cc.EditBox)
            }
            if (cfg["isNotNull"]) {
                if (editBox.string.length === 0) {
                    i18n.t('register_text.No_null')
                    UIManager.showToastUI(cfg["registerName"] + i18n.t('register_text.No_null'), Global.ToastType.Warnning)
                    return false
                } else if (cfg["registerFieldName"] === "phone" && (editBox.string.length < 6 || editBox.string.length > 15 || !(/^\d+$/.test(editBox.string)))) {
                    UIManager.showToastUI(i18n.t('register_text.correct_phone'), Global.ToastType.Warnning)
                    return false
                }
            }
        }

        // 手机验证码
        if (parseInt(this._userLoginConfig["isOpenPhoneCode"]) === 0) {
            if (this.ebPhoneCode.string.length === 0) {
                UIManager.showToastUI(i18n.t('register_text.phone_vfy'), Global.ToastType.Warnning)
                return false
            }
        }

        return true
    }


    onBtnClose(){
        AudioManager.playSound("close");
        this.node.destroy();

    }

    onBtnUpgrade(){
        if (!this.check()) {
            return
        }
        let agentCode = this._bindData && this._bindData["code"];
        if  (!agentCode  && this.agentCodeEb){
            agentCode =  this.agentCodeEb.string;
        }

        let data = {
            "agentUrl": "",
            "channelDomain": "",
            "channelFlag": "",
            "code": this.ebCode.string,
            "codeId": this._codeId === 0 ? "" : this._codeId.toString(),
            "deviceFlag": "",
            "deviceModel": cc.sys.isMobile ? jsb.device.getDeviceModel() : "",
            "deviceType": cc.sys.os === cc.sys.OS_ANDROID ? "1" : "2",
            "domainId": this._channelCode,
            "email": cc.find("email/EditBox", this.nodeContent) ? cc.find("email/EditBox", this.nodeContent).getComponent(cc.EditBox).string : "",
            "ipAdr": "",
            "parentAgentCode": agentCode,
            "phone": this.ebPhoneNum.string || "",
            "phoneCode": this.ebPhoneCode.string,
            "pwd": this.ebPossword.string,
            "qq": cc.find("qq/EditBox", this.nodeContent) ? cc.find("qq/EditBox", this.nodeContent).getComponent(cc.EditBox).string : "",
            "area" : this.selectAreaCodeData && this.selectAreaCodeData.areaNumber,
            "sign": "",
            "uaToken": "",
            "userId": this.ebUserName.string,
            "verifyPwd": this.ebConfirm.string,
            "weChat": cc.find("wechat/EditBox", this.nodeContent) ? cc.find("wechat/EditBox", this.nodeContent).getComponent(cc.EditBox).string : "",
            "webUmidToken": "",
            "currencyType" : Player.getPy("currencyType"),
            //"confirmAgentCurrency" : this.confirmAgentCurrency
        }
        UIManager.showLoadingUI();
        //调用升级的接口
        NetworkLogic.visitorEditUserData(data,function (rec){
            UIManager.hideLoadingUI()
            cc.log("===升级成功rec：",rec)
            UIManager.showToastUI("升级成功",Global.ToastType.OK)
            Player.setPy("userType",0)
            this.node.destroy();
        }.bind(this),function (){
            UIManager.hideLoadingUI()
            //UIManager.showToastUI("升级失败",Global.ToastType.Error)

        }.bind(this))

    }
}
